import {find} from "lodash";
import {VEHICLE_TYPES} from "./constants";

export const setRUTFormat = value => {
  value = value.replace(/[^K0-9\s]/gi, '');
  if (value && value.length > 1) {
    const length = value.length;
    const checkDigit = value.substring(length - 1);
    const rest = value.substring(0, length - 1);
    let lastRest = '';
    let count = 0;
    for (let i = rest.length - 1; i >= 0; i -= 1) {
      if (count === 3) {
        count = 0;
        lastRest = `.${lastRest}`;
      }
      lastRest = `${rest[i]}${lastRest}`;
      count += 1;
    }
    value = `${lastRest}-${checkDigit}`;
  }
  return value;
}

export const currencyToInt = value => {
  let income = value.replace("$", "");
  income = income.split(".").join("");
  return parseInt(income);
}

export const currentChinese = (brandList, brand) =>
    Boolean(
        find(
            brandList,
            (e) => e.VemCodigoMarca === parseInt(brand) && e.VemChino === "true"
        )
    );

export const getVehicleStatusString = (vehicleStatus) =>
    vehicleStatus === "1" ? "NUEVO" : "USADO";

export const findProductByBusinessType = (dataCes, vehicleType, businessType) => {
  const vehicleTypesMap = {
    [VEHICLE_TYPES.MOTO]: dataCes?.VEHICULOS?.MOTO?.NEGOCIOS || [],
    [VEHICLE_TYPES.CAMION]: dataCes?.VEHICULOS?.CAMION?.NEGOCIOS || [],
    [VEHICLE_TYPES.BUS]: dataCes?.VEHICULOS?.BUS?.NEGOCIOS || [],
    [VEHICLE_TYPES.AUTO]: dataCes?.VEHICULOS?.AUTO?.NEGOCIOS || [],
  };

  return find(
      vehicleTypesMap[vehicleType],
      (e) => e.CodTipoNegocio === businessType
  );
};

export const valueIsBetween = (first, second, price) => {
  let max = first >= second ? first : second;
  let min = first <= second ? first : second;

  return max >= price && min <= price;
};